import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchItems } from "../../actions/bannerActions";
import {
  makeBannerPreviewsSelector,
  makeBannerPreviewsAnyKeySelector,
  makeBannerPreviewsFetchStatusSelector,
} from "../../selectors/bannerPreviews";
import { BANNER_SHAPE } from "../../constants/bannerConstants";
import { COLLECTION_FETCH_STATUS_SHAPE } from "../../selectors/collections";
import LoadableCollection from "../../components/ui/loadable/collection";


export function withBanners(WrappedComponent) {

  const WithBanners = class extends Component {

    shouldComponentUpdate(prevProps) {
      if (prevProps.fetchStatus && prevProps.fetchStatus.isFetching) {
        return false
      } else {
        return true
      }
    }

    fetchBanners = (currentPage = 1) => {
      const { fetchItems, fetchStatus } = this.props;

      if (!fetchStatus.isFetching) {
        fetchItems(currentPage);
      }
    };

    render() {
      const { banners, pagination, fetchStatus, children, ...restProps } = this.props;

      return (
        <LoadableCollection fetchStatus={fetchStatus}>
          {
            () => <WrappedComponent
                    {...restProps}
                    banners={banners}
                    pagination={pagination}
                    fetchStatus={fetchStatus}
                    fetchBanners={this.fetchBanners}
                  />
          }
        </LoadableCollection>
      )
    }
  };

  WithBanners.propTypes = {
    banners: PropTypes.arrayOf(PropTypes.shape(BANNER_SHAPE)),
    fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
  };

  const bannersSelector = makeBannerPreviewsSelector();
  const bannersPaginationSelector = makeBannerPreviewsAnyKeySelector('pagination');
  const bannersFetchStatusSelector = makeBannerPreviewsFetchStatusSelector();

  function mapStateToProps(state) {
    return {
      banners: bannersSelector(state),
      pagination: bannersPaginationSelector(state) || {},
      fetchStatus: bannersFetchStatusSelector(state),
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      fetchItems,
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithBanners);
}